<app-breadcrumb [master]="'Rozliczenia'" [parentName]="'Szablon email'" [name]="'Lista'"></app-breadcrumb>
<div class="template-list-container" fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="row">
    <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm">

      <app-month-picker
        class="template-list-filter"
        label="Miesiąc rozliczeniowy" [required]="false"
        name="billingMonth" [(ngModel)]="initialFilters.billingMonth"
      ></app-month-picker>

      <app-dict
        [multiple]="false" label="Firma"
        class="template-list-filter"
        dictType="company"
        [(ngModel)]="initialFilters.company" name="company"
      ></app-dict>

      <app-dict
        [multiple]="false" label="Rodzaj rozliczenia"
        class="template-list-filter"
        dictType="type_of_settlement"
        [(ngModel)]="initialFilters.typeOfSettlement" name="typeOfSettlement"
      ></app-dict>

      <mat-form-field appearance="standard"  class="template-list-filter">
        <mat-label>Aktywny</mat-label>
        <mat-select [(ngModel)]="initialFilters.active" name="active">
          <mat-option [value]="null">Wszystkie</mat-option>
          <mat-option [value]="1">Tak</mat-option>
          <mat-option [value]="0">Nie</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="standard"  class="template-list-filter">
        <mat-label>Wysłany</mat-label>
        <mat-select [(ngModel)]="initialFilters.used" name="used">
          <mat-option [value]="null">Wszystkie</mat-option>
          <mat-option [value]="1">Tak</mat-option>
          <mat-option [value]="0">Nie</mat-option>
        </mat-select>
      </mat-form-field>

    </form>
  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <button (click)="addSettlementTemplate()" [disabled]="!(userPermissions | async).ofwca.write" mat-stroked-button color="primary"
             class="ofwca-add-button"><mat-icon>add</mat-icon> Dodaj szablon</button>
    <span fxFlex></span>
<!--    <button (click)="downloadReport()" [disabled]="!(userPermissions | async).settlement.read_report"-->
<!--            mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>-->
    <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>

  <div fxLayout="column">
    <table mat-table [dataSource]="items" matSort (matSortChange)="sortChanged($event)" multiTemplateDataRows>

      <ng-container matColumnDef="billingMonth">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="billingMonth"> Miesiąc rozliczeniowy </th>
        <td mat-cell *matCellDef="let element" (click)="expandElement(element)">
          {{element.billingMonth}}
        </td>
      </ng-container>
      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="createdAt"> Data dodania </th>
        <td mat-cell *matCellDef="let element" (click)="expandElement(element)">
          {{element.createdAt | date: 'y-MM-dd | HH:mm'}}
        </td>
      </ng-container>
      <ng-container matColumnDef="company">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="company"> Firma </th>
        <td mat-cell *matCellDef="let element" (click)="expandElement(element)">
            {{element.company?.name}}
        </td>
      </ng-container>
      <ng-container matColumnDef="typeOfSettlement">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="typeOfSettlement"> Rodzaj rozliczenia</th>
        <td mat-cell *matCellDef="let element" (click)="expandElement(element)">
         {{element.typeOfSettlement?.name}}
        </td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="active"> Status </th>
        <td mat-cell *matCellDef="let element" (click)="expandElement(element)">
          <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center" >
            <button *ngIf="!element.active" mat-stroked-button [ngClass]="'disabled-button'">Archiwum</button>
            <button *ngIf="element.active" mat-raised-button  [ngClass]="'positive-button'">Aktualny</button>
            <div>
              <mat-chip-list *ngIf="element.used" >
                <mat-chip class="own-matTooltip" color="primary"  matTooltip="Szablon wysłany">W</mat-chip>
              </mat-chip-list>
            </div>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length" class="expanded-row-td">
          <div class="expanded-data" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
            <div fxFlex="100" *ngIf="element == expandedElement">
              <app-settlements-template-view
                *ngIf="!modify"
                fxFlex="100"
                [settlementTemplate]="element"
                (modifyClicked)="modify = true"
                (deleted)="expandedElement = null; loadListData()"
              >
              </app-settlements-template-view>
              <app-add-settlements-template
                *ngIf="modify"
                fxFlex="100"
                [settlementTemplate]="element"
                (closeModification)="modify = false; modificationClosed()"
              >
              </app-add-settlements-template>
<!--              <app-risk-group-view-->
<!--                [riskConfiguration]="element"-->
<!--                (modifyClicked)="modify = true"-->
<!--                [initialFiltersRisk]="initialFilters.risk"-->
<!--                *ngIf="!modify"-->
<!--                fxFlex="100"-->
<!--              ></app-risk-group-view>-->
<!--              <app-risk-group-form-->
<!--                [riskConfiguration]="element"-->
<!--                (closeModification)="modify = false; modificationClosed()"-->
<!--                *ngIf="modify"-->
<!--                fxFlex="100"-->
<!--              ></app-risk-group-form>-->
            </div>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        class="table-row"
        mat-row *matRowDef="let element; let row; columns: displayedColumns;"
        [class.expanded-row]="expandedElement === element"
        [class.not-expanded-row]="expandedElement && expandedElement !== element"
      ></tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="expanded-data-row"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
  </div>

</div>
